import WebApiService from "@/services/webapi.service.js";
import Sito from "@/models/sito.model.js";

const state = {
    siti: null
}

const getters = {

    getSiti: (state) => {
        return state.siti;
    },
    
    getDescrizioneOperativa: (state) => (codiceSito) => {
        if(state.siti){
            let sito =  state.siti.find(item => item.CodiceSito === codiceSito);

            if(sito){
                return sito.DescrizioneOperativa ?? "-";
            }
            else{
                return "-";
            }
        }
        else{
            return "-";
        }
    },

    getSito: (state) => (codiceSito) =>{
        if(state.siti){
            let sito =  state.siti.find(item => item.CodiceSito === codiceSito);
            if(sito){
                return sito ;
            }else{
                return null;
            }
        }else{
            return null;
        }
    },

    getDescrizioneSito: (state) => (codiceSito) =>{
        if(state.siti){
            let sito = state.siti.find(item => item.CodiceSito === codiceSito);
            if(sito){
                return sito.DescrizioneOperativa;
            }else{
                return "-";
            }
        }else{
            return "-";
        }
    },    
    getIndirizzoSito: (state) => (codiceSito) =>{
        if(state.siti){
            let sito = state.siti.find(item => item.CodiceSito === codiceSito);
            if(sito){
                return sito.Indirizzo;
            }else{
                return "-";
            }
        }else{
            return "-";
        }
    },
    getProvinciaSito: (state) => (codiceSito) =>{
        if(state.siti){
            let sito = state.siti.find(item => item.CodiceSito === codiceSito);
            if(sito){
                return sito.Provincia;
            }else{
                return "-";
            }
        }else{
            return "-";
        }
    }
}

const mutations = {

    setSiti: (state, siti) => {
        state.siti = siti;      
    }
}

const actions = {

    getSiti: ({commit}, data) => {                                                                                                              
        return WebApiService.get('siti/GetSiti', data.token).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                  
                    commit("setSiti", data.Data.map(
                        o => { return Object.assign(new Sito(), o) }
                    ));
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}